import styled from '@emotion/styled';
import {
    colorVariables,
    boxSizes,
    mediaQuery,
    breakpoints,
    colors,
    gutterSizes,
    fontSizes,
    fontWeights,
} from '@gumtree/ui-library/src/base/theme';

export const Container = styled.div`
    display: flex;
    align-items: center;
    margin: ${gutterSizes.xlarge} ${gutterSizes.large};
    border-radius: ${boxSizes.borderRadius8};
    box-shadow: 0px 0px ${boxSizes.borderRadius12} 0px rgba(0, 0, 0, 0.20);
    padding: ${gutterSizes.large};
    background: ${colorVariables.backgroundNeutral};
    flex-direction: row;

    ${mediaQuery.until(breakpoints.small)} {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const Left = styled.div`
    flex: 0 0 45%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-right: ${gutterSizes.xlarge};
    box-sizing: border-box;

    ${mediaQuery.until(breakpoints.small)} {
        flex: none;
        padding-right: 0;
        margin-bottom: ${gutterSizes.large};
        align-items: center;
    }
`;

export const LeftContent = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const TextBlock = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: ${gutterSizes.large};

    ${mediaQuery.until(breakpoints.small)} {
        margin-left: 0;
        margin-top: ${gutterSizes.base};
    }
`;

export const Img = styled.img`
    width: 62px;
    height: 68px;
    margin-right: ${gutterSizes.large};
`;

export const Title = styled.div`
    font-size: ${fontSizes.large};
    font-weight: ${fontWeights.bold};
    color: ${colorVariables.textPrimary};
    margin-bottom: ${gutterSizes.base};
    text-align: left;
`;

export const Subtitle = styled.div`
    font-size: ${fontSizes.base};
    color: ${colorVariables.textSecondary};
    margin-bottom: 0;
    text-align: left;
`;

export const Right = styled.div`
    flex: 0 0 55%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;

    ${mediaQuery.until(breakpoints.small)} {
        flex: none;
        width: 100%;
        justify-content: center;
    }
`;

export const ButtonGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${gutterSizes.base};
    width: 100%;

    ${mediaQuery.until(breakpoints.small)} {
        grid-template-columns: 1fr;
    }
`;

export const AnswerButton = styled.button`
    padding: ${gutterSizes.base} 0;
    background: ${colorVariables.backgroundNeutral};
    border: 1px solid ${colorVariables.borderLight};
    border-radius: ${boxSizes.borderRadius4};
    font-size: ${fontSizes.base};
    color: ${colors.darkGrey};
    font-weight: ${fontWeights.normal};
    cursor: pointer;
    transition: border 0.2s;
    width: 100%;
    text-align: center;
    outline: none;

    &:hover, &:focus {
        border-color: ${colors.blade};
    }
`;
